import { createContext } from 'react';
import { State, createState } from '@hookstate/core';

export const errorsContext = createContext<State<Record<string, string[]>>>(createState<Record<string, string[]>>({}));
